import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const LongCalendarWithCallsSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.28914 25.4238C6.42598 25.4238 12.5426 25.9632 18.1988 18.0226M33 20.9831C31.9251 20.9831 28.377 20.1488 25.6806 18.0226" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M18.2033 18.0226C19.224 16.5898 20.1947 14.8805 21.0942 12.8418C22.6578 15.2228 24.2263 16.8723 25.6852 18.0226" stroke="#089981" strokeWidth="2"/>
    </svg>
)

const LongCalendarWithCalls: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {LongCalendarWithCallsSvg(props)}
    </SvgIcon>
));
export default LongCalendarWithCalls